export const NO_CACHE_HEADERS = [
  {'Cache-Control': 'no-cache, must-revalidate, proxy-revalidate'},
  {Pragma: 'no-cache'},
  {Expires: '0'}
]

export const FOUND_STATUS_CODE = 302
